import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.span(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    background-color: ${theme.co.tertiary90};
    min-width: 100%;

    ${theme.typography.heading.desktop.xs};
    border-radius: ${theme.bo.small};
    padding: ${theme.sz.s2} 0;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xxs};
      border-radius: 0;
    }
  `,
);

export const RowWrapper = styled.span(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    width: 50%;
    margin: 0 ${theme.sz.s4};
    color: ${theme.co.secondary50};
  `,
);

export const Title = styled.span(
  ({ theme }) => css`
    min-height: ${theme.sz.s8};

    @media (max-width: ${theme.sz.md}) {
      min-height: ${theme.sz.s6};
    }
  `,
);

export const Icon = styled.img(
  ({ theme }) => css`
    height: ${theme.sz.s5};
    width: ${theme.sz.s5};
    margin-right: ${theme.sz.s2};
  `,
);
